import styled from 'styled-components'
import theme from 'src/styles/theme'

export const PageContainer = styled.div<{isRestocking?: boolean}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    height: 100%;
    background-color: ${({ isRestocking }) => (isRestocking ? theme.colors.lightGray : null)};
`
